"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getInputValues = getInputValues;
/**
 * @param   {HTMLFormElement}   formElement
 * @param   {string}            inputName
 * @returns {FormDataEntryValue|FormDataEntryValue[]}   string or array
 */
function getInputValues(formElement, inputName) {
  let values = new FormData(formElement).getAll(inputName);
  if (values.length === 1) {
    values = values[0];
  }
  return values;
}